import { render, staticRenderFns } from "./MaterialityApprovalsList.vue?vue&type=template&id=c15cba0a"
import script from "./MaterialityApprovalsList.vue?vue&type=script&lang=js"
export * from "./MaterialityApprovalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports